import { render, staticRenderFns } from "./PropertyModalWrapper.vue?vue&type=template&id=47028a84&scoped=true&"
import script from "./PropertyModalWrapper.vue?vue&type=script&lang=js&"
export * from "./PropertyModalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PropertyModalWrapper.vue?vue&type=style&index=0&id=47028a84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47028a84",
  null
  
)

export default component.exports